/* eslint-disable no-extra-parens */
export const forecastsPageIds = [
    'forecasts/current',
    'forecasts/hourly',
    'forecasts/daily'
] as const;

export const alertsPageIds = [
    'alerts',
    'alerts/weather',
    'alerts/spark',
    'alerts/hurricane',
    'alerts/fire',
    'alerts/pollen',
    'alerts/airquality',
    'alerts/severestormrisk'
] as const;

export type PageIdsForPagesWithWidgetType = typeof forecastsPageIds[number] | typeof alertsPageIds[number];

export const isPageWithWidget = (pageId: PageIdsForPagesWithWidgetType): boolean => {
    if (!pageId) {
        return false;
    }

    return (forecastsPageIds.includes(pageId as typeof forecastsPageIds[number]) || alertsPageIds.includes(pageId as typeof alertsPageIds[number]));
};
